import type { Dispatch } from 'redux';
import type { Family } from '@/services/api/types';
import type { UserState, UserAction } from '@/redux/user/types';

export enum Actions {
  SetUserData = 'SetUserData',
  SetUserDataFail = 'SetUserDataFail',

  SetUserFamily = 'SetUserFamily',
  SetUserFamilyFail = 'SetUserFamilyFail',

  SetPointsData = 'SetPointsData',
  SetPointsDataFail = 'SetPointsDataFail',

  SetTooltipData = 'SetTooltipData',
  SetTooltipDataFail = 'SetTooltipDataFail',

  SetCountryData = 'SetCountryData',
  SetCountryDataFail = 'SetCountryDataFail',

  SetLanguageData = 'SetLanguageData',
  SetLanguageDataFail = 'SetLanguageDataFail',

  SetParticipantId = 'SetParticipantId',
  SetParticipantIdFail = 'SetParticipantIdFail'
}

export const setUserData =
  (data: UserState) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetUserData, data });
    } catch (error) {
      dispatch({ type: Actions.SetUserDataFail, error });
    }
  };

export const setUserFamily =
  (family: Family) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetUserFamily, family });
    } catch (error) {
      dispatch({ type: Actions.SetUserFamilyFail, error });
    }
  };

export const setUserPoints =
  (points: number) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetPointsData, points });
    } catch (error) {
      dispatch({ type: Actions.SetPointsDataFail, error });
    }
  };

export const setUserTooltip =
  (seen: boolean) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetTooltipData, seen });
    } catch (error) {
      dispatch({ type: Actions.SetTooltipDataFail, error });
    }
  };

export const setUserCountry =
  (country: string) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetCountryData, country });
    } catch (error) {
      dispatch({ type: Actions.SetCountryDataFail, error });
    }
  };

export const setUserLanguage =
  (language: string) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetLanguageData, language });
    } catch (error) {
      dispatch({ type: Actions.SetLanguageDataFail, error });
    }
  };

export const setParticipantId =
  (id: string) => (dispatch: Dispatch<UserAction>) => {
    try {
      dispatch({ type: Actions.SetParticipantId, id });
    } catch (error) {
      dispatch({ type: Actions.SetParticipantIdFail, error });
    }
  };
